$(function () {


    /*
    |--------------------------------------------------------------------------
    | Configure your website
    |--------------------------------------------------------------------------
    |
    | We provided several configuration variables for your ease of development.
    | Read their complete description and modify them based on your need.
    |
    */

    page.config({
        /*
        |--------------------------------------------------------------------------
        | Disable AOS on mobile
        |--------------------------------------------------------------------------
        |
        | If true, the Animate On Scroll animations don't run on mobile devices.
        |
        */

        disableAOSonMobile: true,

        /*
        |--------------------------------------------------------------------------
        | Smooth Scroll
        |--------------------------------------------------------------------------
        |
        | If true, the browser's scrollbar moves smoothly on scroll and gives your
        | visitor a better experience for scrolling.
        |
        */

        smoothScroll: false,

    });

});
